import React from 'react';
import PropTypes from 'prop-types';

import './SideMenu.sass';

import cx from 'classnames';

import {Helmet} from 'react-helmet';
import {CSSTransitionGroup} from 'react-transition-group';

export default function SideMenu({isOpen, onStateChange, dark, section, children}) {
  return (
    <CSSTransitionGroup
      transitionName="side-menu"
      transitionEnterTimeout={300}
      transitionLeaveTimeout={300}
    >
      {isOpen && (
        <div key="side-menu" className={cx('side-menu', dark && 'side-menu--dark', section && 'side-menu--section')}>
          <Helmet>
            <body className="prevent-scroll"/>
          </Helmet>

          <div className="side-menu__content">
            {children}
          </div>

          <div className="side-menu__close">
            <button
              className="side-menu__close-btn"
              onClick={() => onStateChange(false)}
            />
          </div>
        </div>
      )}
    </CSSTransitionGroup>
  );
}

SideMenu.propTypes = {
  isOpen: PropTypes.bool,
  onStateChange: PropTypes.func,
  children: PropTypes.node,
  dark: PropTypes.bool
};



// WEBPACK FOOTER //
// ./components/sideMenu/SideMenu.js